import type { AvailabilityProduct } from '@travelity/api/services';
import { Box, Typography } from '@mui/material';
import { TagsList } from '@travelity/form/controls';
import { useMemo } from 'react';
import { buildPackageAvailableTimeOptions } from '../../package-form.helpers';

const taxSx = {
    bgcolor: '#DDF0F5',
    color: '#2B395B',
    fontSize: '14px',
    fontWeight: 600,
    p: '10px 16px',
    '&.MuiChip-colorPrimary': {
        bgcolor: '#55B5CF',
        color: '#FFFFFF',
        fontWeight: 400,
    },
    '&:hover': {
        bgcolor: '#AAD9E7',
    },
};

interface PackageAvailableTimePickerProps {
    selectedEvent: AvailabilityProduct;
}

const PackageAvailableTimePicker = ({
    selectedEvent,
}: PackageAvailableTimePickerProps) => {
    const availableTimeOptions = useMemo(
        () => buildPackageAvailableTimeOptions(selectedEvent),
        [selectedEvent]
    );

    return (
        <Box>
            <Typography
                sx={{
                    color: '#2B395B',
                    fontSize: '12px',
                }}
            >
                Select Available Time
            </Typography>
            <TagsList
                name="selectedTime"
                options={availableTimeOptions}
                gap={1}
                maxItems={15}
                tagSx={taxSx}
            />
        </Box>
    );
};

export default PackageAvailableTimePicker;
